import store from '@/stores/store';

export default (to, from, next) => {

    if (store.getters["authStore/selectedRole"]?.business == null) {
        next({ name: 'not-found' })
    }

}